import type { AppDefinition } from '../types';

import { AppHome } from './AppHome';
import { CardBack } from './CardBack';
import { CardFront } from './CardFront';
import { MissRow } from './MissRow';
import type { GramaticaPayload } from './types';

/**
 * Gramática — uma regra por dia.
 *
 * Brazilian Portuguese A1 for a native German speaker who also reads English.
 * The mirror of Grammatik, and deliberately not a translation of it: the two
 * courses run in opposite directions and the interesting content is exactly the
 * part that does not mirror.
 *
 * Each lesson explains its rule in BOTH German and English, and carries an
 * `anchor` naming which of them Portuguese actually behaves like here. Seven of
 * the forty-two also carry a RELIEF — "German made you do this and Portuguese
 * does not" — which is the one thing a course for a bilingual learner can say
 * that no monolingual app can: no noun declension, no verb-second, no third
 * gender, and numbers that count tens first.
 *
 * The anchors are also the part most easily got wrong. Fifteen were corrected
 * across three reviews of the plan before a lesson was authored, so they carry
 * provenance and the seeder refuses production until a Brazilian has read them.
 *
 * Everything structural — the four exercise faces, the reading screen, the
 * progress map — is shared with Grammatik under `src/apps/shared/grammar/`.
 * What lives in this directory is the adapter from the stored Portuguese shape,
 * and the one screen that genuinely differs: a card back that names the
 * accented form when an answer was accepted without its accent.
 */
export const gramaticaApp: AppDefinition<GramaticaPayload> = {
  id: 'gramatica',
  display_name: 'Gramática',
  CardFront,
  CardBack,
  MissRow,
  Home: AppHome,
};
